/* Copyright (c) 2025 Xperi. All Rights Reserved.  */

import { DateTime } from '../../../../../core/utils';

import './FilteredGuideTableSeparatorRow.scss';

interface IFilteredGuideTableSeparatorRowProps {
    startTime: number;
}

const FilteredGuideTableSeparatorRow = ({
    startTime,
}: IFilteredGuideTableSeparatorRowProps): JSX.Element => {
    return (
        <div
            className="filter-guide-table-separator-container"
            data-testid="filtered-guide-table-row"
        >
            <div className="filtered-guide-generic-row">
                <div className="filtered-guide-left-side-table"></div>
                <div
                    className="filtered-guide-right-side-table time-slot-text text"
                    data-testid="filtered-guide-time-slot-text"
                >
                    {new DateTime(startTime * 1000).to12HourClock()}
                </div>
            </div>
        </div>
    );
};

export default FilteredGuideTableSeparatorRow;
